// eslint-disable-next-line strict
module.exports = require('form-data');
